import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {H6Text} from '@buncha/components/core/text';
import {HBox} from '@buncha/components/core/view';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  buyerName: string;
  bagCount: number;
}

const PrintingStickersBanner = (props: Props) => {
  const {body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  return (
    <HBox
      style={[
        styles.bannerBox,
        {backgroundColor: theme?.background?.yellow?.[100]},
      ]}>
      <H6Text
        style={{
          fontFamily: muli?.[700]?.normal,
          color: theme?.text?.blue?.[300],
        }}>
        {body?.printingStickers
          ?.replace('{bagCount}', props?.bagCount)
          ?.replace('{buyerName}', props?.buyerName)}
      </H6Text>
    </HBox>
  );
};

export default React.memo(PrintingStickersBanner);
const styles = StyleSheet.create({
  bannerBox: {
    padding: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
